import { useState } from "react";
import { faqs } from "@/mocks/mangaData";

export default function Faq() {
  const [openId, setOpenId] = useState<string | null>(faqs[0].id);

  return (
    <section id="faq" className="py-12 md:py-20 bg-background-100">
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <div className="text-center mb-8 md:mb-12">
          <span className="inline-flex items-center gap-1.5 text-secondary-600 text-sm font-medium">
            <i className="ri-question-line"></i>
            常见问题
          </span>
          <h2 className="mt-2 font-display text-2xl md:text-4xl text-foreground-950">
            入坑前，你想知道的都在这里
          </h2>
          <p className="mt-2 text-sm md:text-base text-foreground-600">
            关于本命推荐、一生推和入坑作，这些高频问题一次讲清楚。
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((f) => {
            const open = openId === f.id;
            return (
              <div
                key={f.id}
                className={`rounded-xl border transition-colors ${
                  open ? "bg-background-50 border-accent-300" : "bg-background-50/60 border-background-200/70 hover:border-primary-200"
                }`}
              >
                <button
                  onClick={() => setOpenId(open ? null : f.id)}
                  className="w-full flex items-center justify-between gap-3 px-4 md:px-5 py-4 text-left"
                  aria-expanded={open}
                >
                  <span className="flex items-center gap-3">
                    <span
                      className={`w-8 h-8 shrink-0 rounded-lg flex items-center justify-center text-sm ${
                        open ? "bg-accent-500 text-background-50" : "bg-background-200 text-foreground-600"
                      }`}
                    >
                      <i className={open ? "ri-question-fill" : "ri-question-line"}></i>
                    </span>
                    <h3 className="font-display text-base md:text-lg text-foreground-950">{f.q}</h3>
                  </span>
                  <i
                    className={`ri-arrow-down-s-line text-xl text-foreground-500 transition-transform ${
                      open ? "rotate-180" : ""
                    }`}
                  ></i>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    open ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
                  }`}
                >
                  <p className="px-4 md:px-5 pb-4 pl-[60px] text-sm text-foreground-600 leading-relaxed">
                    {f.a}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}